var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lvdb-container",staticStyle:{"height":"100%"}},[(_vm.qrCode)?_c('div',{staticClass:"qr-code-container"},[_c('h4',[_vm._v(" "+_vm._s(_vm.qrCodeText))]),_c('img',{attrs:{"src":_vm.qrCode,"alt":""}})]):_vm._e(),_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"livedabStreamWidget"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }